// // src/components/MatrixBackground.js
// import React from 'react';
// import styled, { keyframes } from 'styled-components';

// const fall = keyframes`
//   0% { 
//     transform: translateY(-100%) translateZ(0px);
//     opacity: 0;
//   }
//   30% { 
//     opacity: 1;
//     transform: translateY(-30%) translateZ(100px); 
//   }
//   100% { 
//     transform: translateY(100%) translateZ(0px);
//     opacity: 0;
//   }
// `;

// const Rain = styled.div`
//   position: fixed;
//   width: 100%;
//   height: 100vh;
//   top: 0;
//   left: 0;
//   background: black;
//   overflow: hidden;
//   z-index: -1;
//   perspective: 1000px;
//   transform-style: preserve-3d;
// `;

// const Line = styled.div`
//   color: #00ff00;
//   font-family: 'Courier New', Courier, monospace;
//   font-size: 1rem;
//   animation: ${fall} 3s linear infinite;
//   position: absolute;
//   top: 0;
//   left: ${({ left }) => left}%;
//   animation-delay: ${({ delay }) => delay}s;
//   text-shadow: 0 0 8px #00ff00;
//   transform-style: preserve-3d;
//   transform: ${({ depth }) => `translateZ(${depth}px)`};
// `;

// const MatrixBackground = () => {
//   const [lines, setLines] = React.useState([]);

//   React.useEffect(() => {
//     const generateLines = () => {
//       return Array.from({ length: 100 }, (_, index) => ({
//         key: index,
//         left: Math.random() * 100,
//         delay: Math.random() * 3,
//         depth: Math.random() * 500
//       }));
//     };

//     // Initial generation
//     setLines(generateLines());

//     // Regenerate lines every 3 seconds to keep animation fresh
//     const interval = setInterval(() => {
//       setLines(generateLines());
//     }, 3000);

//     // Cleanup interval on unmount
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <Rain>
//       {lines.map(line => (
//         <Line
//           key={line.key}
//           left={line.left}
//           delay={line.delay}
//           depth={line.depth}
//         >
//           1010101010
//         </Line>
//       ))}
//     </Rain>
//   );
// };

// export default MatrixBackground;
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import useInterval from '@use-it/interval';

// Constants
const VALID_CHARS = `abcdefghijklmnopqrstuvwxyz0123456789$+-*/=%"'#&_(),.;:?!\\|{}<>[]^~`;
const STREAM_MUTATION_ODDS = 0.02;

const MIN_STREAM_SIZE = 15;
const MAX_STREAM_SIZE = 50;

const MIN_INTERVAL_DELAY = 50;
const MAX_INTERVAL_DELAY = 100;

const MIN_DELAY_BETWEEN_STREAMS = 0;
const MAX_DELAY_BETWEEN_STREAMS = 8000;

const getRandInRange = (min, max) =>
	Math.floor(Math.random() * (max - min)) + min;

const getRandChar = () =>
	VALID_CHARS.charAt(Math.floor(Math.random() * VALID_CHARS.length));

const getRandStream = () =>
	new Array(getRandInRange(MIN_STREAM_SIZE, MAX_STREAM_SIZE))
		.fill()
		.map(_ => getRandChar());

const getMutatedStream = stream => {
	const newStream = [];
	for (let i = 1; i < stream.length; i++) {
		if (Math.random() < STREAM_MUTATION_ODDS) {
			newStream.push(getRandChar());
		} else {
			newStream.push(stream[i]);
		}
	}
	newStream.push(getRandChar());
	return newStream;
};

const RainStream = props => {
	const [stream, setStream] = useState(getRandStream());
	const [topPadding, setTopPadding] = useState(stream.length * -50);
	const [intervalDelay, setIntervalDelay] = useState(null);

	useEffect(() => {
		setTimeout(() => {
			setIntervalDelay(getRandInRange(MIN_INTERVAL_DELAY, MAX_INTERVAL_DELAY));
		}, getRandInRange(MIN_DELAY_BETWEEN_STREAMS, MAX_DELAY_BETWEEN_STREAMS));
	}, []);

	useInterval(() => {
		if (!props.height) return;
		if (!intervalDelay) return;

		if (topPadding > props.height) {
			setStream([]);
			const newStream = getRandStream();
			setStream(newStream);
			setTopPadding(newStream.length * -44);
			setIntervalDelay(null);
			setTimeout(
				() =>
					setIntervalDelay(
						getRandInRange(MIN_INTERVAL_DELAY, MAX_INTERVAL_DELAY),
					),
				getRandInRange(MIN_DELAY_BETWEEN_STREAMS, MAX_DELAY_BETWEEN_STREAMS),
			);
		} else {
			setTopPadding(topPadding + 44);
		}
		setStream(getMutatedStream);
	}, intervalDelay);

	return (
		<div
			style={{
				fontFamily: 'matrixFont',
				color: '#20c20e',
				writingMode: 'vertical-rl',
				textOrientation: 'upright',
				userSelect: 'none',
				whiteSpace: 'nowrap',
				marginTop: topPadding,
				marginLeft: -15,
				marginRight: -15,
				textShadow: '0px 0px 8px rgba(32, 194, 14, 0.8)',
				fontSize: 50,
				opacity: 0.3,
			}}>
			{stream.map((char, index) => (
				<span
					key={index}
					style={{
						marginTop: -12,
						opacity: index < 6 ? 0.1 + index * 0.15 : 1,
					}}>
					{char}
				</span>
			))}
		</div>
	);
};

const MatrixBackground = props => {
	const containerRef = useRef(null);
	const [containerSize, setContainerSize] = useState(null); // ?{width, height}

	useEffect(() => {
		const boundingClientRect = containerRef.current.getBoundingClientRect();
		setContainerSize({
			width: boundingClientRect.width,
			height: boundingClientRect.height,
		});
	}, []);

	const streamCount = containerSize ? Math.floor(containerSize.width / 26) : 0;

	return (
		<div
			style={{
				background: 'black',
				position: 'fixed',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0,
				overflow: 'ignore',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'center',
			}}
			ref={containerRef}>
			{new Array(streamCount).fill().map(_ => (
				<RainStream height={containerSize?.height} />
			))}
		</div>
	);
};

export default MatrixBackground;